import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRating = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onRatingError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while submitting your rating.',
        );
    };

    const onRatingSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Rating submitted successfully.');
        callbackFn();
    };

    const submitRating = (data: any, callbackFn: () => void) => {
        const url: HttpConfig = {
            url: `api/v1/trip-logs/rate`,
            method: 'post',
            data,
            skipAuth: true,
            skipLogoutRedirect: true,
        };

        request(url, onRatingSuccess(callbackFn), setLoading, onRatingError);
    };

    return { submitRating, loading };
};

export default useRating;
